import { motion } from "motion/react";
import { HugeiconsIcon } from "@hugeicons/react";
import { Mail01Icon } from "@hugeicons/core-free-icons";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function ContactSection() {
  const navigate = useNavigate();
  return (
    <section className="border-border border-t py-20 sm:py-28">
      <div className="mx-auto max-w-2xl px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="bg-brand-muted mx-auto mb-6 flex size-12 items-center justify-center rounded-2xl">
            <HugeiconsIcon icon={Mail01Icon} className="text-brand size-5" />
          </div>

          <h2 className="font-display text-foreground text-3xl font-normal tracking-tight sm:text-4xl">
            Still have questions?
          </h2>
          <p className="text-muted-foreground mx-auto mt-3 max-w-md text-base leading-relaxed">
            Our team is here to help. Reach out and we'll get back to you within
            24 hours.
          </p>

          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Button
              size="lg"
              className="bg-foreground text-background hover:bg-foreground/90 gap-2 border-none cursor-pointer"
              onClick={() => navigate("/support")}
            >
              <HugeiconsIcon
                icon={Mail01Icon}
                className="size-4"
                data-icon="inline-start"
              />
              Contact Support
            </Button>
            {/* <Button variant="outline" size="lg" className="gap-2">
              Join Discord
              <HugeiconsIcon
                icon={ArrowRight01Icon}
                className="size-4"
                data-icon="inline-end"
              />
            </Button> */}
          </div>

          <p className="text-muted-foreground/50 mt-6 text-sm">
            hello@rayloop.ai &middot; Response time: &lt; 24h
          </p>
        </motion.div>
      </div>
    </section>
  );
}
